import React, { useState } from 'react';
import { Dropdown } from "react-bootstrap"
import { Link } from "react-router-dom"
import { Routes } from '../../../utils/Routes';
import { PermissionEnum } from '../../../types/PermissionEnum';
import { useAuthContext } from '../../Auth/AuthProvider';
import './JobMenuItems.scss';

interface JobMenuItemsProps {
    jobId: string;
    menu: string;
}
const JobMenuItems = ({
    jobId,
    menu
}: JobMenuItemsProps): React.ReactElement => {
    const isDisplayLoadsEnabled = useAuthContext().userHasPermission(PermissionEnum.ViewLoads);

    let menuName = '';
    if (menu === "jobDetails") menuName = "Job Details"
    if (menu === "equipmentsForTab") menuName = "Equipment"
    if (menu === "vosForTab") menuName = "VOS"
    if (menu === "stageSummary") menuName = "Stage Summary"
    if (menu === "inventory") menuName = "Inventory"
    if (menu === "jobLogs") menuName = "Job Logs"
    if (menu === "jobActivity") menuName = "Current Activity"
    if (menu === "driverPool") menuName = "Driver Pool"
    if (menu === "sandAllocation") menuName = "Sand Allocation"
    if (menu === "jobMetrics") menuName = "Job Metrics"
    if (menu === "jobMap") menuName = "Map"
    if (menu === "jobLoads") menuName = "Loads"

    return (
        <>
            {/* For Laptop */}
            <div className="Row JobMenuItems-ToggleButtonsContainer">
                {/* <div className="JobMenuItems-LeftToggleButton JobMenuItems-ActiveButton">
                    <p className="JobMenuItems-ButtonText">Job Details</p>
                </div> */}
                <Link
                    to={{
                        pathname: `${Routes.JOB_PROFILE.route}${jobId}`,
                    }}
                    className={`JobMenuItems-LeftToggleButton JobMenuItems-ButtonText ${!isDisplayLoadsEnabled &&
                        'JobMenuItems-LeftToggleButton-Disabled'} ${menu === 'jobDetails' && 'JobMenuItems-ActiveButton'}`}
                >
                    Job Details
                </Link>
                <Link
                    to={{
                        pathname: `${Routes.STAGE_SUMMARY.route}${jobId}`,
                    }}
                    className={`JobMenuItems-CenterToggleButton JobMenuItems-ButtonText ${!isDisplayLoadsEnabled &&
                        'JobMenuItems-RightToggleButton-Disabled'} ${menu === 'stageSummary' && 'JobMenuItems-ActiveButton'}`}
                >
                    Stage Summary
                </Link>
                <Link
                    to={{
                        pathname: `${Routes.INVENTORY.route}${jobId}`,
                    }}
                    className={`JobMenuItems-CenterToggleButton JobMenuItems-ButtonText ${!isDisplayLoadsEnabled &&
                        'JobMenuItems-RightToggleButton-Disabled'} ${menu === 'inventory' && 'JobMenuItems-ActiveButton'}`}
                >
                    Inventory
                </Link>
                <Link
                    to={{
                        pathname: `${Routes.JOB_LOGS.route}${jobId}`,
                    }}
                    className={`JobMenuItems-CenterToggleButton JobMenuItems-ButtonText ${menu === 'jobLogs' && 'JobMenuItems-ActiveButton'}`}
                >
                    Job Logs
                </Link>
                <Link
                    to={{
                        pathname: `${Routes.JOB_ACTIVITY.route}${jobId}`,
                    }}
                    className={`JobMenuItems-CenterToggleButton JobMenuItems-ButtonText ${!isDisplayLoadsEnabled &&
                        'JobMenuItems-RightToggleButton-Disabled'} ${menu === 'jobActivity' && 'JobMenuItems-ActiveButton'}`}
                >
                    Current Activity
                </Link>
                <Link
                    to={{
                        pathname: `${Routes.DRIVER_POOL.route}${jobId}`,
                    }}
                    className={`JobMenuItems-CenterToggleButton JobMenuItems-ButtonText ${menu === 'driverPool' && 'JobMenuItems-ActiveButton'}`}
                >
                    Driver Pool
                </Link>
                <Link
                    to={{
                        pathname: `${Routes.DAILY_SAND_ALLOCATIONS.route}${jobId}`,
                    }}
                    className={`JobMenuItems-CenterToggleButton JobMenuItems-ButtonText ${menu === 'sandAllocation' && 'JobMenuItems-ActiveButton'}`}
                >
                    Sand Allocations
                </Link>
                <Link
                    to={{
                        pathname: `${Routes.JOB_METRICS.route}${jobId}`,
                    }}
                    className={`JobMenuItems-CenterToggleButton JobMenuItems-ButtonText ${menu === 'jobMetrics' && 'JobMenuItems-ActiveButton'}`}
                >
                    Job Metrics
                </Link>
                <Link
                    to={{
                        pathname: `${Routes.JOB_MAP.route}${jobId}`,
                    }}
                    className={`JobMenuItems-CenterToggleButton JobMenuItems-ButtonText ${!isDisplayLoadsEnabled &&
                        'JobMenuItems-RightToggleButton-Disabled'} ${menu === 'jobMap' && 'JobMenuItems-ActiveButton'}`}
                >
                    Map
                </Link>
                <Link
                    to={{
                        pathname: `${Routes.JOB_LOADS.route}${jobId}`,
                    }}
                    className={`JobMenuItems-RightToggleButton JobMenuItems-ButtonText ${!isDisplayLoadsEnabled &&
                        'JobMenuItems-RightToggleButton-Disabled'} ${menu === 'jobLoads' && 'JobMenuItems-ActiveButton'}`}
                >
                    Loads
                </Link>
            </div>

            {/* For Tab */}
            <div className="Row JobMenuItems-ToggleButtonsContainer-For-Tab">
                <Dropdown className="JobMenuItems-CenterToggleButton-Container">
                    <Dropdown.Toggle
                        variant="link"
                        id="dropdown-basic"
                        className="JobMenuItems-CenterToggleButton JobMenuItems-CenterToggleButton-Container common-tab-dropdown"
                    >
                        <span>{menuName}</span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item>
                            <Link
                                to={{
                                    pathname: `${Routes.JOB_PROFILE.route}${jobId}`,
                                }}
                                className={`JobMenuItems-CenterToggleButton JobMenuItems-ButtonText ${!isDisplayLoadsEnabled &&
                                    'JobMenuItems-RightToggleButton-Disabled'} ${menu === 'jobDetails' && 'JobMenuItems-ActiveButton'}`}
                            >
                                Job Details
                            </Link>
                        </Dropdown.Item>
                        <Dropdown.Item>
                            <Link
                                to={{
                                    pathname: `${Routes.EQUIPMENT.route}${jobId}`,
                                }}
                                className={`JobMenuItems-CenterToggleButton JobMenuItems-ButtonText ${!isDisplayLoadsEnabled &&
                                    'JobMenuItems-RightToggleButton-Disabled'} ${menu === 'equipmentsForTab' && 'JobMenuItems-ActiveButton'}`}
                            >
                                Equipment
                            </Link>
                        </Dropdown.Item>
                        <Dropdown.Item>
                            <Link
                                to={{
                                    pathname: `${Routes.VOS.route}${jobId}`,
                                }}
                                className={`JobMenuItems-CenterToggleButton JobMenuItems-ButtonText ${!isDisplayLoadsEnabled &&
                                    'JobMenuItems-RightToggleButton-Disabled'} ${menu === 'vosForTab' && 'JobMenuItems-ActiveButton'}`}
                            >
                                VOS
                            </Link>
                        </Dropdown.Item>
                        <Dropdown.Item>
                            <Link
                                to={{
                                    pathname: `${Routes.STAGE_SUMMARY.route}${jobId}`,
                                }}
                                className={`JobMenuItems-CenterToggleButton JobMenuItems-ButtonText ${!isDisplayLoadsEnabled &&
                                    'JobMenuItems-RightToggleButton-Disabled'} ${menu === 'stageSummary' && 'JobMenuItems-ActiveButton'}`}
                            >
                                Stage Summary
                            </Link>
                        </Dropdown.Item>
                        <Dropdown.Item>
                            <Link
                                to={{
                                    pathname: `${Routes.INVENTORY.route}${jobId}`,
                                }}
                                className={`JobMenuItems-CenterToggleButton JobMenuItems-ButtonText ${!isDisplayLoadsEnabled &&
                                    'JobMenuItems-RightToggleButton-Disabled'} ${menu === 'inventory' && 'JobMenuItems-ActiveButton'}`}
                            >
                                Inventory
                            </Link>
                        </Dropdown.Item>
                        <Dropdown.Item>
                            <Link
                                to={{
                                    pathname: `${Routes.JOB_LOGS.route}${jobId}`,
                                }}
                                className={`JobMenuItems-CenterToggleButton JobMenuItems-ButtonText ${menu === 'jobLogs' && 'JobMenuItems-ActiveButton'}`}
                            >
                                Job Logs
                            </Link>
                        </Dropdown.Item>
                        <Dropdown.Item>
                            <Link
                                to={{
                                    pathname: `${Routes.JOB_ACTIVITY.route}${jobId}`,
                                }}
                                className={`JobMenuItems-CenterToggleButton JobMenuItems-ButtonText ${!isDisplayLoadsEnabled &&
                                    'JobMenuItems-RightToggleButton-Disabled'} ${menu === 'jobActivity' && 'JobMenuItems-ActiveButton'}`}
                            >
                                Current Activity
                            </Link>
                        </Dropdown.Item>
                        <Dropdown.Item>
                            <Link
                                to={{
                                    pathname: `${Routes.DRIVER_POOL.route}${jobId}`,
                                }}
                                className={`JobMenuItems-CenterToggleButton JobMenuItems-ButtonText ${menu === 'driverPool' && 'JobMenuItems-ActiveButton'}`}
                            >
                                Driver Pool
                            </Link>
                        </Dropdown.Item>
                        <Dropdown.Item>
                            <Link
                                to={{
                                    pathname: `${Routes.DAILY_SAND_ALLOCATIONS.route}${jobId}`,
                                }}
                                className={`JobMenuItems-CenterToggleButton JobMenuItems-ButtonText ${menu === 'sandAllocation' && 'JobMenuItems-ActiveButton'}`}
                            >
                                Sand Allocations
                            </Link>
                        </Dropdown.Item>
                        <Dropdown.Item>
                            <Link
                                to={{
                                    pathname: `${Routes.JOB_METRICS.route}${jobId}`,
                                }}
                                className={`JobMenuItems-CenterToggleButton JobMenuItems-ButtonText ${menu === 'jobMetrics' && 'JobMenuItems-ActiveButton'}`}
                            >
                                Job Metrics
                            </Link>
                        </Dropdown.Item>
                        <Dropdown.Item>
                            <Link
                                to={{
                                    pathname: `${Routes.JOB_MAP.route}${jobId}`,
                                }}
                                className={`JobMenuItems-CenterToggleButton JobMenuItems-ButtonText ${!isDisplayLoadsEnabled &&
                                    'JobMenuItems-RightToggleButton-Disabled'} ${menu === 'jobMap' && 'JobMenuItems-ActiveButton'}`}
                            >
                                Map
                            </Link>
                        </Dropdown.Item>
                        <Dropdown.Item>
                            <Link
                                to={{
                                    pathname: `${Routes.JOB_LOADS.route}${jobId}`,
                                }}
                                className={`JobMenuItems-CenterToggleButton JobMenuItems-ButtonText ${!isDisplayLoadsEnabled &&
                                    'JobMenuItems-RightToggleButton-Disabled'} ${menu === 'jobLoads' && 'JobMenuItems-ActiveButton'}`}
                            >
                                Loads
                            </Link>
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </>
    )
}

export default JobMenuItems;